export function transformTimeStringToMinutes(time: string): number | undefined {
  const [hoursStr, minutesStr] = time.split(':');

  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (isNaN(hours) || isNaN(minutes)) {
    return undefined;
  }

  return hours * 60 + minutes;
}
